<fs-sidenav-menu>
  <div class="title">
    <h2>
      Projects
    </h2>
    @if (allowCreate) {
      <button
          mat-stroked-button
          (click)="create()">
        Create
      </button>
    }
  </div>
  <div class="search">
    <fs-filter [config]="config"></fs-filter>
  </div>
  <fs-sidenav-menu-content>
    @for (project of projects; track project) {
      <div class="project">
        <fs-badge
          [image]="project.avatar?.tiny"
          [size]="30">
        </fs-badge>
        <div class="project-info">
          <span class="project-header">
            {{ project.name }}
          </span>
          <div class="project-links">
            <a
                [routerLink]="['../projects', project.id, 'tasks']"
                (click)="close()">
              Tasks
            </a>
            <a
                [routerLink]="['../projects', project.id, 'board']"
                (click)="close()">
              Board
            </a>
            <a
                [routerLink]="['../projects', project.id, 'plans']"
                (click)="close()">
              Plans
            </a>
            <a
                [routerLink]="['../projects', project.id, 'docs']"
                (click)="close()">
              Docs
            </a>
            <a
                [routerLink]="['../projects', project.id, 'images']"
                (click)="close()">
              Mockups
            </a>
            <a
                [routerLink]="['../projects', project.id, 'data']"
                (click)="close()">
              Data
            </a>
            <a
                [routerLink]="['../projects', project.id, 'scenarios']"
                (click)="close()">
              Scenarios
            </a>
            <a
                [routerLink]="['../projects', project.id, 'kbs']"
                (click)="close()">
              Knowledge Bases
            </a>
            <a
                [routerLink]="['../projects', project.id, 'testcases']"
                (click)="close()">
              Test Cases
            </a>
            <a
                [routerLink]="['../projects', project.id, 'settings']"
                (click)="close()">
              Settings
            </a>
          </div>
        </div>
      </div>
    }
  </fs-sidenav-menu-content>
  <fs-sidenav-menu-actions class="actions">
    <button
        mat-button
        color="primary"
        (click)="close()"
        type="button"
        class="full-width">
      Done
    </button>
  </fs-sidenav-menu-actions>
</fs-sidenav-menu>